import { action } from '@/lib/api';
import clone from '@/lib/clone';
import mergeByProp from '@/lib/mergeByProp';
import pushChangesQueueItem from '@/redux/actions/pushChangesQueueItem.js';
import { store } from '@/redux/lib/configureStore';
import { getDeep } from '@shared/utils/getDeep.js';
import { setDeep } from '@shared/utils/setDeep.js';
import appScreenSelectors from '../selectors/appScreenSelectors';

const appActions = {
  set(path, payload) {
    return new Promise((resolve) => {
      const state = store.getState();
      const activeApp = clone(appScreenSelectors.activeApp(state));
      const newApp = setDeep(activeApp, path, payload);
      const value = getDeep(path, newApp);
      pushChangesQueueItem('app', { appId: activeApp?.id, appVersion: activeApp?.version, path, value }, newApp);
      resolve(newApp);
    });
  },

  merge(path, prop, payload) {
    payload = Array.isArray(payload) ? payload : [payload];
    return new Promise((resolve) => {
      const state = store.getState();
      const activeApp = clone(appScreenSelectors.activeApp(state));
      const newApp = setDeep(activeApp, path, (deepValue) => mergeByProp(prop, deepValue || [], payload));
      const value = getDeep(path, newApp);
      pushChangesQueueItem('app', { appId: activeApp?.id, appVersion: activeApp?.version, path, value }, newApp);
      resolve();
    });
  },

  filter(path, fn) {
    return new Promise((resolve) => {
      const state = store.getState();
      const activeApp = clone(appScreenSelectors.activeApp(state));
      const newApp = setDeep(activeApp, path, (deepValue) => deepValue.filter(fn));
      const value = getDeep(path, newApp);
      pushChangesQueueItem('app', { appId: activeApp?.id, appVersion: activeApp?.version, path, value }, newApp);
      resolve();
    });
  },

  append(path, payload) {
    return new Promise((resolve) => {
      const state = store.getState();
      const activeApp = clone(appScreenSelectors.activeApp(state));

      let newApp;
      let value;

      const id = payload?.id;
      if (id) {
        path = `${path}[id:${id}]`;
      }

      if (id) {
        newApp = setDeep(activeApp, path, payload);
        value = getDeep(path, newApp);
      } else {
        newApp = setDeep(activeApp, path, (deepValue) => (Array.isArray(deepValue) ? [...(deepValue || []), payload] : deepValue || []));
        value = getDeep(path, newApp);
      }

      pushChangesQueueItem('app', { appId: activeApp?.id, appVersion: activeApp?.version, path, value }, newApp);
      resolve();
    });
  },

  deleteApp(id) {
    return new Promise((resolve) => {
      action('DELETE_APP', { id });
      pushChangesQueueItem('app', { operation: 'delete', appId: id });
      resolve();
    });
  }
};

export default appActions;
